import RouteInfo from '@ember/routing/-private/route-info';
import { isPresent } from '@ember/utils';
import { TransformsList } from 'cio/utils/analytics/transforms';

type ActivityLogTab = 'identified' | 'anonymous';

function getActivityLogsTabName(tab: ActivityLogTab) {
  return {
    identified: 'Identified',
    anonymous: 'Anonymous',
  }[tab];
}

const Transforms: TransformsList = {
  dataIndexView(data) {
    let typeRoute = data.route!.find((route: RouteInfo) => route.name === 'data-index.type');
    let type = typeRoute!.params!.type as string;

    return {
      'Data Type': (
        {
          attributes: 'Attributes',
          events: 'Events',
        } as any
      )[type],
      'Filtered By Name': isPresent(data.route!.queryParams.search) ? 'Yes' : 'No',
    };
  },

  deliveriesOrDraftsView(data) {
    return {
      'Deliveries or Drafts': (
        {
          'outbox.list.drafts': 'Drafts',
          'outbox.list.deliveries': 'Deliveries',
        } as any
      )[data.route!.name],
    };
  },

  activityLogView(data) {
    return {
      'Activity Tab': getActivityLogsTabName(data.route!.params.tab as ActivityLogTab),
    };
  },

  specificActivityView(data) {
    return {
      'Activity Tab': getActivityLogsTabName(data.route!.params.tab as ActivityLogTab),
      'Merged Anonymous Event': data.isAnonymousMergeEvent,
      'Merge Activity Type': data.isPeopleMergeEvent,
    };
  },

  moreLogsLoaded(data) {
    return {
      'Activity Tab': getActivityLogsTabName(data.route!.params.tab as ActivityLogTab),
    };
  },
};

export default Transforms;
